import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import dotObject from 'dot-object';
import ErrorKeeper from "../ErrorKeeper"; // eslint-disable-next-line import/no-unresolved

function getEmceePath() {
  if (window.location.href.includes('emcee')) {
    return window.location.hash.split('#')[1];
  }
}

var getFormattedEventWithTags = function getFormattedEventWithTags(event) {
  var message = '';
  var tags = {};
  var args = event.message;
  var pathname = getEmceePath();
  message = args.filter(function (arg) {
    return typeof arg === 'string' || arg.constructor !== Object;
  }).join(' ');
  tags = args.filter(function (arg) {
    return arg.constructor === Object;
  }).reduce(function (arg, tagsAccumulated) {
    return _objectSpread(_objectSpread({}, tagsAccumulated), dotObject.dot(arg));
  }, {});
  window.Sentry.withScope(function (scope) {
    scope.setExtra('arguments', args);
  });
  message = message || JSON.stringify(args);
  return _objectSpread(_objectSpread(_objectSpread({}, event), pathname && {
    request: _objectSpread(_objectSpread({}, event.request), {}, {
      url: pathname
    })
  }), {}, {
    message: message,
    // This is display error message in the header
    exception: message,
    tags: _objectSpread(_objectSpread({}, event.tags), tags)
  });
};

var beforeSend = function beforeSend(event) {
  var formattedEvent = Array.isArray(event.message) ? getFormattedEventWithTags(event) : event;
  ErrorKeeper.add(formattedEvent.event_id);
  return formattedEvent;
};

var ignoredHTTPTraffic = [/api.segment.io/, /google-analytics.com/, /https:\/\/xid\./, /pingdom.net/, /stats.g.doubleclick.net/, /api-private.atlassian.com\/gasv3/, /hn.inspectlet.com/, /events.launchdarkly.com/, /gateway\/api\/session\/heartbeat/, /logx.optimizely.com\/v1\/events/];

var beforeBreadcrumb = function beforeBreadcrumb(crumb) {
  if (crumb.type === 'http' && ignoredHTTPTraffic.some(function (denyUrl) {
    return denyUrl.test(crumb.data.url);
  })) return false;
  return crumb;
};
/* eslint-disable no-console -- referenced on purpose */


export var originalConsoleError = console.error;
export function initSentry(sentryConfig) {
  if (window.Sentry) {
    window.Sentry.onLoad(function () {
      window.Sentry.init({
        dsn: sentryConfig.dsn,
        beforeBreadcrumb: beforeBreadcrumb,
        environment: sentryConfig.environment,
        attachStacktrace: true,
        release: sentryConfig.releaseVersion,
        denyUrls: [/cdn.segment.com/],
        beforeSend: beforeSend
      });
    });
    var oldConsoleError = console.error; // $FlowFixMe because property console.error is not writable

    console.error = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      window.Sentry.captureMessage(args, {
        level: 'error'
      });
      return oldConsoleError.apply(console, args);
    };
  }
}

function SHA256(_x) {
  return _SHA.apply(this, arguments);
}

function _SHA() {
  _SHA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
    var msgUint8, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!('TextEncoder' in window && 'crypto' in window)) {
              _context.next = 10;
              break;
            }

            msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
            // $FlowIssue Crypto defs missing from flow https://github.com/facebook/flow/issues/5019

            _context.next = 4;
            return window.crypto.subtle.digest('SHA-256', msgUint8);

          case 4:
            hashBuffer = _context.sent;
            // hash the message
            hashArray = _toConsumableArray(new Uint8Array(hashBuffer)); // convert buffer to byte array

            hashHex = hashArray.map(function (b) {
              return b.toString(16).padStart(2, '0');
            }).join(''); // convert bytes to hex string

            return _context.abrupt("return", hashHex);

          case 10:
            return _context.abrupt("return", null);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _SHA.apply(this, arguments);
}

export function setSentryUserId(_x2) {
  return _setSentryUserId.apply(this, arguments);
}

function _setSentryUserId() {
  _setSentryUserId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
    var saltedId, userIdHashed;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!window.Sentry) {
              _context2.next = 6;
              break;
            }

            saltedId = "KE3WvP2iYT14lIfa".concat(id, "ATtNdgf1Qhok0D9bhv");
            _context2.next = 4;
            return SHA256(saltedId);

          case 4:
            userIdHashed = _context2.sent;
            window.Sentry.configureScope(function (scope) {
              scope.setUser({
                id: userIdHashed
              });
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setSentryUserId.apply(this, arguments);
}